module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Headquarters, Army of Northern Virginia"), _c('br'), _vm._v(" Seven Miles South of Havre de Grace, Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterDateline1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("August 22, 1863")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/CSA.jpg"
    }
  }), _vm._v(" It was the noonday lull, the cool breezes of morning giving way to a still midday heat. Gen. Robert E. Lee, commander, Army of Northern Virginia, rode in silence. The road before him was packed with troops, men marching at a vigorous pace. He trotted past the troops, edging along fencerows, cutting out into pastures and orchards to make speed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The men were moving, maintaining a grueling pace of three miles an hour, hunched over, rifles balanced on shoulders or slung inverted, hats pulled down over brows to shield eyes from the noonday glare, faces sweat-streaked, dust kicking up in swirling, choking clouds. Some saw him and gave a salute or shout as he cantered along; others, sunk into the hypnotic rhythm of the march, were unaware of his presence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("These men had marched over a hundred miles in the past week and fought a brutal three-day running battle in killing heat, and it showed. The usual banter of a victorious army on the march was gone; the high spirits that should have echoed after their overwhelming victories over the Army of the Potomac were not showing this day. Exhaustion had overwhelmed exhilaration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rode in silence, lost in thought. Walter Taylor, his aide-de-camp, the staff, even the secretary of state, Judah Benjamin, sensing he wished to ride alone to think, trailed a respectful distance behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the smashing defeat of Sickles he expected Grant to wait, or perhaps even to start transferring his army by train and boat down to Washington, there to assume a defensive posture through the fall and winter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But to take an aggressive path? To cross the river and move south, perhaps straight at him. No, he had not expected that. After every defeat dealt the Union Army over the last year, his opponents had always retreated, regrouped, and waited several months before venturing another blow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was like facing an opponent in chess. The traditional opening of a king or queen’s pawn is expected, but then, instead, the man across the table puts his knight out first. That was usually the move of a fool…or could it be that of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("master")]), _vm._v(" or someone who sensed or planned something Lee could not yet ascertain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who was Grant? In that tight-knit cadre of old comrades from West Point, the old professional army of the frontier, of Mexico, or garrison duty in East Coast fortifications, Grant was one man he could not remember. He knew the man had served in Mexico and gained distinction there for personal bravery and leadership, but as an army commander? He had beaten Beauregard at Shiloh, captured an entire army at Fort Donelson and Vicksburg. He was used to victory…perhaps that could be turned against him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were the rumors as well about the man’s drinking, but then again, the army had always been a hard-drinking lot. In the case of Grant, the few who knew him said it had been brought on by a fit of melancholia when stationed out on the West Coast, separated from his wife and children.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Longstreet, who did know him, dismissed the drinking, saying that it was a demon his old friend would have overcome, especially when he had returned to the army and given the responsibility of command.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All the others he had faced so far, McClellan, the fool Pope, the slow-moving Burnside, the hard-driving but morally weak Hooker, even Meade and Sickles, he could read them, and he could read as well the thinking, the rhythm, the mentality of the Army of the Potomac…reft by internal dissent and political maneuverings, hampered by even more political maneuverings in Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he was no longer facing the Army of the Potomac, and even in Washington he sensed a change. Halleck was out, and just this morning Judah Benjamin had suggested that perhaps Stanton’s days were numbered as well. A staff officer of Sickles’s, a prisoner, had bitterly complained that his general had moved without coordination with Grant, and everyone at Sickles’s headquarters knew that Stanton had sent out contradictory orders for which “someone would pay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Grant’s corps commanders—Ord, McPherson, Banks, Burnside. He knew the mettle of Burnside, knew the fumbling reputation of Banks, who survived due to political influence. Word on McPherson was his men worshipped him and declared him to be the best corps commander in any army.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he knew him as well, as superintendent at West Point. The memory of McPherson caused him to smile. McPherson had risen to become the top-ranking officer of cadets. He was a moral man, honest, open-handed, respected by all. John Bell Hood had been his roommate and he loved him like a brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of all the potential opponents this war had forced him to confront, James Birdseye McPherson was the one opponent he wished he did not have to face. There was a deep bond of affection, that of a mentor for a beloved student.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now I will have to face him, and turn all that was good between us into a tool, a weapon to defeat him in battle.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Edward Ord, new to his rank of corps commander, was a man who supposedly loved a good head-on fight, a man like Hood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And their troops. These Union soldiers from the West were used to victory; they were used to tough fighting in the scorching heat and bayous of Mississippi, the tangled forests of Tennessee, the swamps of Louisiana. They were fighters—and filled with a belief in themselves. In battle, such belief is often what tips the scale between victory and defeat. Though tough soldiers, the men of the Army of the Potomac seemed to carry an innate sense that defeat would always be their ultimate fate, and that had come true at Union Mills and Gunpowder River.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wished he had another month, time to evaluate, to maneuver and observe Grant, to spar with him to get a taste of him, before moving in for the kill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The pasture ahead dropped down into a glen and he welcomed the momentary pause as he loosened Traveler’s reins and gave his companion a chance to drink in the shade of the willows lining the shallow creek. There the air was damp and rich, the brook rippling and sparkling with reflected light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To his left a battery of guns was clattering over a rough-hewn wooden bridge, troops left the road to wade across the knee-deep stream. A few men playfully splashed each other. Sergeants called for canteens, handing them off to details to fill while the column pushed on, the water bearers enjoying their work for a few minutes, some tossing off packs, haversacks, and cartridge boxes and collapsing into the water to cool off, before picking up their gear and filled canteens to double-time back into the column.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("More than a few men lay in the shadow of the trees, barefoot, soaking their feet, one of the men gingerly wrapping torn strips of cloth around his bleeding and blistered heels. At the sight of the general some came to attention. A provost guard watching the group nervously declared the men, exhausted troops from a Virginia regiment, had been given passes to fall out of the march for a few minutes but would catch up to their unit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee said nothing. He nodded and then, gathering Traveler’s reins, trotted across the stream and up the bank through the high river grass, birds kicking up around him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Old Thomas Jackson would never have stood for the boys falling out like that. He’d have shouted for them to get back in the ranks and march till they dropped, but today was not the day for that. Reports from the previous week’s march were that hundreds of men, listed as missing in action, had actually collapsed and died in the forced marching in hundred-degree heat. He therefore had sent word down that those unable to keep up today were to be treated leniently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he came up out of the streambed he saw a low church steeple, a small village of a few dozen homes, the windows of some showing limp Confederate flags, others shuttered and closed. Longstreet’s headquarters flag fluttered out in a gentle breeze near the church, an awning set up in front of it, with staff gathering around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uniforms showed gold braid. He saw Stuart still astride his horse, leaning over, talking with Beauregard. Hood, sitting on a chair under the awning, head back, was obviously asleep. Seeing him coming up, men began to stir, staff moving about, setting chairs around a table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A corporal offered to take Traveler’s reins, and Lee with a sigh dismounted. On stiff legs he walked toward the gathering, returning the salutes of those waiting for him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Someone nudged Hood, who looked around sleepily and then stood up. Stuart dismounted, taking off his plumed hat as he stepped under the awning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("These were his old warriors and Providence had been kind in this fight, sparing all of them yet again. Not a division commander had been lost in this last fight, thank God, though Pickett had lost three of his five brigade commanders and the others were wounded. He caught a glimpse of Pickett standing nervously to one side, the man breaking eye contact when Lee looked at him for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Under the awning Longstreet pointed to a chair at the head of the table. Lee settled down, a servant bringing to him what appeared to be a miracle, lemonade that was actually iced, and he gladly took it, draining half the glass. Benjamin sat down by his right side, Taylor moved in behind Lee, while his cavalry escort dismounted, the men then walking their mounts back down to the stream to water them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The corps commanders gathered around the table and sat down, division commanders stood behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Stuart,” Lee began, “what is the latest news?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, sir, we lost our outpost and telegraphy connection at Carlisle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shortly after six this morning, sir. Yankee cavalry hit them hard. Our men were forced to retreat and we lost all connection.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what other word is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, all our telegraph connections that can report quickly on Harrisburg are down. The outposts we still have are at Shippensburg, Hanover Junction, Frederick, and Gettysburg.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he spoke he pointed out the positions on the map.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We had a report at midmorning that the Yankees were also crossing by ferry at Wrightsville, cavalry,” he paused, “and infantry. It is also reported they are starting to build a pontoon bridge as well at that location. We then lost our outpost at York about two hours ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Grant’s first move,” Longstreet interjected, “is to cut our telegraph outposts, blind us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’d have done the same,” Lee replied noncommittally. He had hoped they could have held contact for most of the day. The use of telegraphs for such reports was something new for the Army of Northern Virginia, but given the vast front they now operated on, literally all of eastern Maryland and south central Pennsylvania, he had hoped to keep these precious lines up awhile longer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So any information we have now, sir,” Stuart continued, “is nearly as old as our first reports, couriers have to carry them back to our remaining posts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And those reports?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The same, sir. Grant pushed the bridge across during the night at Harrisburg, and they started moving before dawn. Railroad equipment was sighted as well. Moved by train up to the bridge north of Harrisburg, across the river, and down the right bank. Apparently they are already laying track and replacing bridges we’d torn up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Units?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Definitely corps strength or more. McPherson’s Corps was in the lead. The report I just mentioned from York indicated infantry in corps strength preparing to cross at Wrightsville. That’s it, so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’d lead with McPherson,” Hood said softly. “We all know he is a good man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee nodded in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that is it?” Lee asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry, sir, but that is all I can report now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is not your fault, General Stuart,” Lee replied, holding his hand up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He did not add that now, more than ever, he regretted the audacity of the raid attempted a week ago by Wade Hampton. He had felt some reluctance to adopt Stuart’s bold plan, to launch Hampton on a raid up toward Reading to gather intelligence on Grant, sow panic, disrupt rail transportation, and perhaps even skirt the edge of Philadelphia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant’s cavalry, backed by infantry, had relentlessly hunted Wade down, killed him, and wiped out his entire brigade. Those men would have been invaluable now for shadowing Grant. The only forces deployed to shadow Grant were two regiments detached from his nephew Fitz Lee’s Brigade. That was nowhere near enough to harass Grant, to slow him, and at this moment, far more importantly, to gain knowledge of his intentions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee studied the map for a moment, finishing his iced lemonade.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What would I do?")]), _vm._v(" He wondered. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I will not put myself in Grant’s shoes, not yet. I’ll do so when I know the man better. Don’t assume he will do what I would do.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned back from the table and motioned for another glass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Comments?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’ll come straight at us,” “Pete” Longstreet said. “He’s just securing his right flank at Carlisle. The main push will come from York to Hanover Junction, then to Baltimore using the Northern Central Railroad for supplies. He’ll use the rail line for supplies and come straight down those tracks toward Baltimore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete fell silent for a moment. Lee nodded for his old warhorse to continue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If he started this last night, I think he was hoping that we would still be tangled up along the Susquehanna, mopping up Sickles. Our men exhausted, worn down. He then pivots.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Longstreet spoke he brushed his hand across the map to indicate the move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pins us north of Baltimore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Precisely why I ordered this forced march back to Baltimore today,” Lee replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded toward the road down which the endless column flowed by, the men slowing in their passage at the sight of Lee and his lieutenants under the awning not fifty yards away. Guards along the road could be heard chanting over and over, “Keep moving, boys. Yes, it’s General Lee. Don’t disturb them. Keep moving, boys….”")]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "539",
      "src": "Images/41.gif",
      "width": "418"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If he does that,” Lee said, “we’ve slipped the noose and Grant will just reoccupy the ground Sickles tried to take. Let him have it, then we are inside Baltimore, behind fortifications, and he can attack us till doomsday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve learned to have a healthy respect for this man,” Beauregard said softly, the lilt of his Louisiana accent soft and pleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on, sir,” Lee replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d be nervous about getting ourselves pinned inside of Baltimore. Look at the way he maneuvered between Forts Henry and Donelson, the way he encircled Vicksburg from the rear. If we stay in Baltimore, he might very well envelope us, circle around, and reconnect to his supplies through Washington. Do that, and he frees up the garrison of Washington to act as an offensive force, too. Sir, I’d be cautious about that move. We don’t want Grant to gain control of the forty thousand men still pinned down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good advice, General Beauregard, but if that threat should arise, it will be five days, perhaps a week from now. But would you concur with General Longstreet that he will turn at Carlisle and come straight at us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beauregard lowered his gaze, staring intently at the map for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Honestly, sir, I don’t know. I do not know this terrain, the land, the roads the way you men do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hood cleared his threat and Lee turned to face the commander of his Second Corps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on, General Hood. Your thoughts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d agree with General Longstreet,” Hood replied, “except for one thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“McPherson being in the lead and marching on Carlisle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that is?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir. You and I know McPherson. I believe Grant brought him east to be his fast-moving corps, his Jackson.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hood hesitated, realizing he had unintentionally offered an insult.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or the task you now do so ably, General Longstreet,” Hood cried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No insult taken, sir,” Pete said, just offering a smile and a nod.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please continue, General Hood,” Lee interjected.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I was Grant, and wanted the strike to come due south, I’d have placed McPherson in Wrightsville and built the first bridge there, not at Harrisburg. I think we can read into this, sir, that perhaps Grant’s intent is not to come due south, but rather to swing wide.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hood gestured toward the map and motioned with his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A broad sweeping march down the Cumberland Valley. To turn our flank, perhaps even spring into Virginia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee did not reply. Hood had raised a point. He next turned to Jeb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Stuart? Your opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most likely straight at us, sir. He can close in three to four days, using the intact railroad for support. Swinging down the valley will take more time, and the Yankees always are slower than us. Add in that repairing the railroad will tie them up further. We tore that railroad in the Cumberland Valley apart for just that reason, sir, but kept the Northern Central intact in case we had to eventually move back to Harrisburg. Grant will take advantage of that and come straight at us looking for a fight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“May I interject something, sir?” Judah Benjamin, the Confederate secretary of state, asked quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course, sir. I always value your opinion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am not a military man, sir, but I can look at this from the political side.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Lincoln administration has suffered two devastating blows in less than two months. Your victories at Union Mills and these last few days on this ground. Your victories have brought Maryland officially to our side as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Longstreet shifted a bit but said nothing. Only the day before Pete had spoken derisively of Maryland’s failure to raise even a single division to join the ranks. Only a few thousand Marylanders had so far volunteered; the rest were taking a wait-and-see attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Judah looked up at Pete and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know, General, you are disappointed that there has been no levy en masse by our brothers in Maryland, but remember they have endured two years of oppression by Lincoln and his cronies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All the more reason for them to rally to the colors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That time will come.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When the war is over and we have won,” Pete replied coolly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gentlemen, let us focus on the moment,” Lee interjected smoothly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Longstreet lowered his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The political pressure on Lincoln is, after what you achieved these last few days, all but overwhelming. His coalition is on the point of collapse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wish to heaven he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("would")]), _vm._v(" collapse. When are they going to learn they can’t beat us?” Beauregard interjected. If not for the presence of Lee, he would have used more forceful words. All those around the table would have eagerly added to them, but none dared to voice their hatred of this effort to conquer them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sickles was a War Democrat, the darling of that group, and now he is defeated and in disgrace,” Benjamin said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does anyone know how he is?” Lee asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s in Philadelphia,” Stuart said. “He’ll live, but I regret to say, sir, that we just got word that General Warren died this morning in one of our field hospitals.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a moment of silence, someone behind Lee sighing with a whispered comment, “Damn this war.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Warren had been one of them, or rather they had once been one with him. Another comrade of West Point gone, a devout man, well liked on both sides.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Benjamin had fallen silent out of respect. At a gesture from Lee he went on. “There is no real political motive for the War Democrats of the North to continue to support Lincoln, but there is precious little they can do at this moment to stop him. Congress is adjourned, the rats having fled when we first threatened the capital. For all practical purposes Lincoln has a dictatorship at this moment, but he must do something with that, and his lone remaining chance is Grant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you think he will order Grant to come straight at us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, sir, I don’t,” Judah said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pray why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s his last card. Lincoln is holding one last card, and he is now looking us straight in the eyes. Once he plays it, well, the drama will be decided as to whether that card is trump or not. I suspect he’ll buy a little more time. The War Democrats can announce their withdrawal of support, riots can erupt again in New York and elsewhere, but I think our opponent will not lay that card down until something is in place to hedge his bet with.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about France?” Beauregard asked. “I heard that you said their intervention is all but certain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beauregard, proud of his French heritage, was always promoting the idea that France would eventually come to their side, as she did back during the First Revolution.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Judah smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not a direct quote, sir,” Judah replied with a cagey smile, “but close enough. Yes, Emperor Napoleon the Third will come in, but will that impact us here over the next month or two? I doubt it. If he sorties with his fleet to try to break the blockade at Wilmington, Charleston, or even at the mouth of the Chesapeake, I dare say the Yankee navy and heavy ironclads will make short work of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, the French, as always, will play their own game to their own advantage. They will not help directly, only indirectly, and that will be along the coast of Texas, in support of their mad affair in Mexico. Even if they did break the blockade there, even if they broke the blockade at New Orleans, it would be long months before that impacted this front here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And frankly, gentleman, as secretary of state, though I wish for their help now, I certainly do not look forward to cleaning up the mess when we finally win and then have to kick them back out, because once involved on our side they will demand payment of some kind or another.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you don’t see any change that will affect us here and now?” Beauregard asked. There was a trace of sadness in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, sir. And Lincoln knows that, too. Sorry, gentlemen, but don’t look to France for any major changes in the situation you now face here in Maryland.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Back to the original issue then,” Lee said, “the here and now of this moment. For all these reasons, what do you think Grant will do, Mr. Secretary?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just that, General Lee. I heard the report you received but yesterday that a colored division had joined Grant’s army. If he waits you out another two weeks, might he not gain another few divisions of colored troops, perhaps a few more battalions of artillery, more supplies, a few more brigades of remounts for cavalry? Might he not actually repair the rail line in the Cumberland Valley clear down to Hagerstown and thus give himself even more mobility? Might he not wait and force you to take the initative and in so doing choose the ground? Perhaps, sir, might he not just simply bypass you completely and march down the valley, cross into Virginia, and march on Richmond?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is hard for me to see him doing that,” Lee replied slowly, sipping again at his refilled glass of lemonade. “Moving on Richmond or waiting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your views, sir?” Judah asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If I were Grant, I would attack now, and with everything I have. My army has endured two months of hard campaigning; we took heavier-than-expected losses in our last action.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could not help but raise his head for a few seconds and gaze again at Pickett, who stood silent, frozen in place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Five of the original nine divisions that started this campaign two and a half months ago have taken grievous losses. My sense of Grant is that he will come straight on, hoping to catch us exhausted, perhaps still strung out on a march back to Baltimore. Force us then to turn and fight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That is why I ordered this forced march today, no matter how painful it is for the men out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gestured toward the road, where the weary columns continued to march by, and felt a wave of pity for his men. As they passed they undoubtedly knew that, yet again, he was deciding their fate. He had to do what was right for his country, and what was right for them, too. Dozens, perhaps a hundred or more, might die today during this march, but through their sacrifice all could rest in Baltimore, and by tomorrow the situation would be clearer. He pitied the thousands of wounded whom he had ordered to be loaded on ambulances and evacuated by any means possible back to the city. Their ordeal would be horrific this day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee was silent and lowered his head. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tomorrow we shall know. By then it will be clear whether Grant has turned south, coming straight on, or not. We can refit in Baltimore then and plan our next move.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hated this. He wished that right now telegraph keys were clicking, telling him which way Grant was moving, either coming straight on or, as Hood suggested, swinging wide on a flanking march to the southwest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In almost every battle in the past, we knew their intentions.")]), _vm._v(" This time it was different, and that was indeed troubling. And yet, at Chancellorsville he had been caught off guard and turned near defeat into an overwhelming victory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just one more victory, gentlemen,” Lee said softly, surveying his lieutenants and the secretary of state. “Whether he comes due south or tries to flank us, all we seek is one more victory—and the war is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All around him nodded in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Keep the troops moving, gentlemen. I want the entire army into Baltimore as quickly as possible, and then they can rest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Stuart, starting tomorrow I want a strong screen moved forward toward General Grant. Give your men time to rest this afternoon and into tomorrow. Report to me tonight for orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, a problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Many of our mounts are worn. I dare say half our horses need reshoeing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then find new mounts in the city.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, city horses, well, they just aren’t fit for cavalry. Draught horses, mostly. We’re starting to sweep this area clean of remounts. I must have several days at least to refit after the hard ride of the last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rest your men today. Get them off the roads. Concentrate at a place of your choosing between here and Baltimore, then report to me as ordered. Send some of your staff back to the city to see what arrangements can be made for your refitting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gentlemen, I want this army to make twenty-five miles today. I know it will be a hard march. But I promise you at least a day of rest tomorrow. As I said before, be liberal with those who cannot keep up. We are not an army in retreat, and those who fall out will surely rejoin the ranks. They are good men, so treat the exhausted, the ill, with respect; make that clear to your provost guards.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All nodded in agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We meet tomorrow in Baltimore, and there will plan our next move.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The look in his eyes was clear indication of dismissal. The group began to break up, officers calling for their mounts, staff, and escorts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee caught General Pickett’s eye and motioned for him to come over, the crestfallen division commander yielding with a certain reluctance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Longstreet, would you join us for a moment?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee stepped out from under the awning into the warm afternoon sun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Pickett, sir, I am disappointed in the report I received regarding your action at Gunpowder River.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, our blood was up,” Pickett replied defensively. “We would not run before Yankees.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you destroyed your division, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pickett looked at him, eyes wide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee looked over at Longstreet. Pickett was his old friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete gave no indication either way of his wishes. He knew Longstreet was in a quandary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I had hoped that in actions to come, General Pickett, it would be your division, which had been the heaviest division in my army, to see victory through. The honor might have been yours to lead a charge that could have won the war.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He paused for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, I shall not relieve you of command. But know, sir, that I shall be watching you closely henceforth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Lee,” Pickett replied icily, “if you do not have confidence in my ability, sir, then accept my resignation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee flushed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have no wish or time for such a result,” Lee replied sharply, controlling his anger. “I need you and what is left of your division. I need every man, every experienced field commander I can find. Just do your duty, and follow orders, next time, to the letter. That is what I expect of you now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Features pale, Pickett stood motionless. Slowly he saluted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned and walked off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think you should have relieved him,” Pete said quietly, waiting till Pickett was out of earshot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps. But controlled, under your direct observation, he can still lead. General Longstreet, I shall see you tonight in Baltimore. Perhaps by this time tomorrow the picture will be clearer and we will see our next move.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope so, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee looked at him closely. Now was not the time to show hesitation, even if it did whisper to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know so, General Longstreet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He walked off, signaling for Traveler. An orderly brought his horse up; he mounted and fell in alongside the endless column, into the boiling clouds of dust, moving south toward Baltimore.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94eb7f06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312342982_ch02.vue
// module id = 72
// module chunks = 0